import { SelectInput } from 'canoe';
import { Field, FieldAttributes, useFormikContext } from 'formik';
import React, { useEffect, useMemo } from 'react';

import { Filter, FilterEnglishNames, FilterTypes } from './types';

const filterTypes = Object.entries(FilterEnglishNames).map(([key, value]) => ({
  value: key,
  label: value,
}));

interface Props {
  availableFilters: FilterTypes[];
}

export const FilterTypeSelector = ({ availableFilters }: Props) => {
  const { values, setFieldValue, setFieldTouched, dirty } = useFormikContext<Filter>();

  const availableFilterTypes = useMemo(
    () => filterTypes.filter((f) => availableFilters.indexOf(f.value as FilterTypes) > -1),
    [availableFilters],
  );

  useEffect(() => {
    if (dirty) {
      // reset the operand value every time we switch between trait types
      setFieldValue('operation.operand', '', false);
      setFieldTouched('operation.operand', false, false);
    }
  }, [values.type]);

  return (
    <Field name="type">
      {({ field }: FieldAttributes<any>) => (
        <SelectInput
          {...field}
          items={availableFilterTypes}
          selectedItem={filterTypes.find((i) => i.value === values.type)}
          clearable={false}
          onSelect={(item: any) => setFieldValue('type', item.value, false)}
        />
      )}
    </Field>
  );
};
